import { useEffect, useState } from "react";
import VideoUpload from "./VideoUpload";
import ThumbnailSelector from "./ThumbnailSelector";
import { toast } from "react-toastify";
const dataURLToBlob = (dataURI, type) => {
  const byteString = atob(dataURI.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type });
};

function convertVideoToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = () => {
      reject(new Error("Error reading file"));
    };

    reader.readAsDataURL(file);
  });
}

const WantAdVideoUpload = ({
  onUpload,
  url,
  videoUploadProgress,
  setThumbnailError,
  handleFormValues,
  setVideoUrlError,
  wantAdData,
  thumbnailImgUrlError,
  setVideoUrll,
  setVideoThumbnailUrl,
}) => {
  const [videoFile, setVideoFile] = useState(() =>
    wantAdData?.isEdit && url ? true : false,
  );
  const [videoUrl, setVideoUrl] = useState(url);
  const [isThumbnailSelected, setIsThumbnailSelected] = useState(false);
  const [uploadStep, setUploadStep] = useState("upload");
  useEffect(() => {
    setVideoUrl(url);
  }, [url]);
  useEffect(() => {
    if (wantAdData?.isEdit) {
      if (videoUrl && wantAdData?.videoUrl) {
        setIsThumbnailSelected(true);
      }
    }
  }, [wantAdData?.isEdit]);
  const handleVideoUpload = async (file) => {
    try {
      const base64 = await convertVideoToBase64(file);
      const binaryData = dataURLToBlob(base64, file.type);

      await onUpload(binaryData, "video");
      toast.success("Video uploaded successfully!");
      setUploadStep("thumbnail");
      setIsThumbnailSelected(false);
    } catch (error) {
      console.error("Error uploading video:", error);
      toast.error("Error uploading video!");
      throw error;
    }
  };
  const handleThumbnailSelect = async (thumbnailBlob) => {
    try {
      setIsThumbnailSelected(true);
      await onUpload(thumbnailBlob, "image");
      toast.success("Thumbnail uploaded successfully!");
    } catch (error) {
      console.error("Error uploading thumbnail:", error);
      toast.error("Error uploading thumbnail!");
    }
  };
  useEffect(() => {
    if (videoUrl && !isThumbnailSelected) {
      setThumbnailError(true);
    } else {
      setThumbnailError(false);
    }
  }, [isThumbnailSelected, videoUrl]);
  useEffect(() => {
    if (videoFile && wantAdData?.videoUrl == "") {
      setVideoUrlError(true);
    } else {
      handleFormValues({ ...wantAdData, videoUrl: "" });
    }
  }, [videoFile]);
  return (
    <div className="min-h-screen bg-background py-12">
      {uploadStep === "upload" ? (
        <>
          <VideoUpload
            onUpload={handleVideoUpload}
            setVideo={setVideoFile}
            setVideoUrlError={setVideoUrlError}
            url={videoUrl}
            setVideoThumbnailUrl={setVideoThumbnailUrl}
            setVideoUrl={setVideoUrll}
            videoUploadProgress={videoUploadProgress}
          />
          {videoFile && wantAdData?.videoUrl == "" && (
            <span className="d-block mb-20 mt-0  py-12 red-marked-wrap off-15">
              Please click the above button to save the video
            </span>
          )}
        </>
      ) : (
        <div className="max-w-2xl mx-auto p-4">
          <ThumbnailSelector
            videoUrl={videoUrl}
            onSelect={handleThumbnailSelect}
          />
          {thumbnailImgUrlError && (
            <span className="red-marked-wrap d-block mt-2">
              Please Select Thumbnail from the Video
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default WantAdVideoUpload;
